import { useCallback } from 'react'

import { createNotification } from '@/app/module/notifications/store/actions'
import { ERROR_UPDATE_API_KEY_SERVER } from '@/app/module/user/definitions'
import { UpdateAPIKeyPayload } from '@/app/module/user/types'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useUpdateAuthToken = () => {
  const dispatch = useAppDispatch()
  const [mutate, res] = esApi.useUpdateUserAuthTokenMutation()

  const updateToken = useCallback(
    async (tokenId: number, body: UpdateAPIKeyPayload) => {
      try {
        await mutate({ tokenId, body }).unwrap()
        return true
      } catch (e) {
        dispatch(
          createNotification({
            'update-api-key-error': {
              type: 'error',
              message: getErrorMessage(e, ERROR_UPDATE_API_KEY_SERVER),
            },
          }),
        )
        return false
      }
    },
    [mutate, dispatch],
  )

  return [updateToken, res] as const
}
